import { yupResolver } from "@hookform/resolvers/yup";
import React, { useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import {
  useLocation,
  useNavigate,
  useOutletContext,
  useParams,
} from "react-router";
import classes from "./CertificateSettings.module.scss";
import {
  certificateSettingsSchema,
  createSeries,
} from "../../../../utils/mainTabs/distribute/createSeries";
import { useDispatch, useSelector } from "react-redux";
import Input from "../../../../components/Common/Input/Input";
import Button from "../../../../components/Common/Button/Button";
import {
  getCertificateActionHandler,
  getShotClassesActionHandler,
  postCertificateActionHandler,
} from "../../../../store/actions/actionHandlers/distributeActionHandler";
import ViewIcon from "../../../../components/Common/SvgIcons/TableIcons/ViewIcon";
import ViewCertificateModal from "./ViewCertificate/ViewCertificateModal/ViewCertificateModal";
import PreviousIcon from "../../../../components/Common/SvgIcons/CommonIcons/PreviousIcon";
import {
  postSeriesProgramActionHandler,
  updateProgramActionHandler,
} from "../../../../store/actions/actionHandlers/organizeActionHandler";
import moment from "moment";
import { setErrorHandler } from "../../../../store/actions/actionHandlers/errorActionHandler";
import { errorTypes } from "../../../../utils/errorTypes";
import { distribute } from "../../../../utils/mainTabs/distribute/distribute";
import { setSeriesDataAction } from "../../../../store/actions/actionCreators/distributeActionCreator";
import { FormattedMessage } from "react-intl";

const CertificateSettings = () => {
  const pageSize = 9;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  const { formValues, setFormValues, tenantName, pathType } =
    useOutletContext();
  const { formFields } = createSeries.certificateSettings;
  const [fields, setFields] = useState([]);
  const [certificateLoader, setCertificateLoader] = useState(false);
  const [certificateData, setCertificateData] = useState([]);
  const [isViewModal, setIsViewModal] = useState(false);
  const [postProgramLoader, setPostProgramLoader] = useState(false);
  const distributeState = useSelector((state) => state.distributeReducer);
  const {
    certificateByProgramId,
    selctedShotclassData,
    classAndCollectionDataByProgramId,
  } = distributeState;

  const methods = useForm({
    defaultValues: formValues,
    resolver: yupResolver(certificateSettingsSchema),
  });
  const {
    handleSubmit,
    watch,
    setValue,
    getValues,
    formState: { errors },
  } = methods;
  const certificateVal = watch(["Certificate", "Title"]);
  const commonState = useSelector((state) => state.commonReducer);
  const { colors } = commonState;

  const onSubmit = (data) => {
    if (
      selctedShotclassData?.length === 0 &&
      location.pathname === createSeries.certificateSettings.path(tenantName)
    ) {
      dispatch(
        setErrorHandler(
          errorTypes.WARN,
          "At least select one Shotclass/collection to proceed......"
        )
      );
    } else {
      setFormValues({ ...formValues, ...data });
      setValue("Title", formValues?.Name);
      let shotClassList = "",
        tags = "";
      if (
        location.pathname === createSeries.certificateSettings.path(tenantName)
      ) {
        selctedShotclassData?.forEach((item, index) => {
          shotClassList =
            shotClassList +
            "0" +
            "," +
            item?.ID +
            "," +
            (index + 1) +
            (selctedShotclassData?.length !== index + 1 ? ";" : "");
        });
      } else {
        classAndCollectionDataByProgramId?.forEach((item, index) => {
          shotClassList =
            shotClassList +
            "0" +
            "," +
            item?.ShotClass?.ID +
            "," +
            (index + 1) +
            (classAndCollectionDataByProgramId?.length !== index + 1
              ? ";"
              : "");
        });
      }
      data?.Tags?.forEach((item, index) => {
        tags =
          tags + item?.TagName + (data?.Tags?.length !== index + 1 ? "," : "");
      });
      const obj = {
        CanDisplayClassPostDuedate: data?.CanDisplayClassPostDuedate,
        Count: 0,
        DueDate: data?.CanDisplayClassPostDuedate
          ? ""
          : moment(data?.DueDate).format("ddd, DD MMM YYYY"),
        ImageUrl:
          location.pathname ===
          createSeries.certificateSettings.path(tenantName)
            ? data?.ImageUrl?.MediaUri
            : data?.ImageUrl,
        IsSelfPacedProgram: data?.IsSelfPacedProgram,
        IsSpreadProgram: data?.IsSpreadProgram,
        LearningCredits: "",
        ListOfClasses: shotClassList,
        Name: data?.Name,
        NoDaysToNotifyBeforeDueDate: data?.NoDaysToNotifyBeforeDueDate,
        Order: "0",
        PageNum: 1,
        Status: "Saved",
        Tags: tags,
        Type: "Program",
      };
      setPostProgramLoader(true);

      if (
        location.pathname ===
        `${createSeries.editPath(tenantName)}/${
          params?.programId
        }/certificateSettings`
      ) {
        const updatedObj = {
          ...obj,
          ID: params?.programId,
          Count: 20,
        };
        dispatch(
          updateProgramActionHandler(updatedObj, navigate, tenantName)
        ).then((res) => {
          if (res?.status === 200 && res?.data) {
            setPostProgramLoader(false);
            dispatch(setErrorHandler(errorTypes.SUCCESS, res?.data));
            navigate(distribute.seriesPath(tenantName));
            dispatch(setSeriesDataAction([]));
            dispatch(
              getShotClassesActionHandler(
                "WithoutVTLT",
                false,
                "Published",
                "Program",
                "none",
                "none",
                1,
                pageSize
              )
            );
          }
        });
      } else {
        dispatch(
          postSeriesProgramActionHandler(
            obj,
            dispatch,
            navigate,
            pathType,
            tenantName
          )
        ).then((res) => {
          if (res?.status === 200 && res?.data) {
            setPostProgramLoader(false);
            dispatch(setErrorHandler(errorTypes.SUCCESS, res?.data));
            navigate(distribute.seriesPath(tenantName));
            dispatch(setSeriesDataAction([]));
            dispatch(
              getShotClassesActionHandler(
                "WithoutVTLT",
                false,
                "Published",
                "Program",
                "none",
                "none",
                1,
                pageSize
              )
            );
          }
        });
        if (certificateVal[0] && certificateVal[1]) {
          const certificateObj = {
            CertificateID: certificateVal[0],
            ProgramName: data?.Name,
            Title: data?.Title,
            Type: true,
          };
          dispatch(postCertificateActionHandler(certificateObj));
        }
      }
    }
  };

  const onViewClick = () => {
    setIsViewModal(true);
    setValue("Title", formValues?.Name);
  };

  const previousClick = () => {
    if (
      location.pathname ===
      `${createSeries.copyPath(tenantName)}/${
        params?.programId
      }/certificateSettings`
    )
      navigate(
        `${createSeries.copyPath(tenantName)}/${
          params?.programId
        }/notificationSettings`
      );
    else if (
      location.pathname ===
      `${createSeries.editPath(tenantName)}/${
        params?.programId
      }/certificateSettings`
    )
      navigate(
        `${createSeries.editPath(tenantName)}/${
          params?.programId
        }/notificationSettings`
      );
    else {
      setFormValues({
        ...formValues,
        Title: getValues("Title"),
        Certificate: getValues("Certificate"),
      });
      navigate(createSeries.notificationSettings.path(tenantName));
    }
  };

  useEffect(() => {
    setFields(formFields(certificateLoader, certificateData));
  }, [formFields, dispatch, certificateData, certificateLoader]);

  useEffect(() => {
    if (certificateByProgramId) {
      setValue("Certificate", certificateByProgramId?.CertificateID);
      setValue("Title", certificateByProgramId?.Title);
    }
  }, [certificateByProgramId, setValue]);

  useEffect(() => {
    dispatch(
      getCertificateActionHandler(setCertificateLoader, setCertificateData)
    );
  }, [dispatch]);

  return (
    <>
      <FormProvider {...methods}>
        <form
          className={classes.certificate_settings}
          onSubmit={handleSubmit(onSubmit)}
        >
          <div className={classes.form}>
            {fields?.map((item) => {
              return (
                <div key={item.key} className={classes.item}>
                  <Input
                    key={item.key}
                    label={item.label}
                    name={item.name}
                    type={item.type}
                    labelColor={item.labelColor}
                    error={errors?.[item?.name]?.message}
                    hidden={item.hidden}
                    placeholder={item.placeholder}
                    accept={item.accept}
                    onChange={item.onChange}
                    width={item.width}
                    valueArr={item.valueArr}
                    loading={item.loading}
                    fieldName={item.fieldName}
                    fieldValue={item.fieldValue}
                  />
                  {certificateVal[0] && item.name === "Certificate" && (
                    <div className={classes.view} onClick={onViewClick}>
                      <ViewIcon fill={colors.theme} />
                    </div>
                  )}
                </div>
              );
            })}
          </div>
          <div className={classes.footer}>
            <div className={classes.previous}>
              <PreviousIcon fill={colors.theme} />
              <span className={classes.previous_text} onClick={previousClick}>
                Previous
              </span>
            </div>
            <div className={classes.btn}>
              <Button
                label={<FormattedMessage id="P_SAVE_TXT" />}
                small
                dark
                type="submit"
                backgroundColor={postProgramLoader ? undefined : "#D31B61"}
                loading={postProgramLoader}
              />
            </div>
          </div>
        </form>
      </FormProvider>
      <ViewCertificateModal
        isViewModal={isViewModal}
        setIsViewModal={setIsViewModal}
        title={certificateVal[1]}
      />
    </>
  );
};

export default CertificateSettings;
